import theme from '@d-id/studio/src/theme';
import { AgentGrounding } from '@d-id/types';
import styled from '@emotion/styled';
import { List } from '@mui/material';
import React from 'react';
import { GroundingListItem } from './GroundingListItem';
import { GroundingStates } from './GroundingSelection';

const StyledList = styled(List)`
    width: 100%;
    padding-block: 0;
    padding: 10px 0;
    gap: 10px;
`;

const StyledListDivider = styled.div`
    width: calc(100% - 32px);

    margin: 0 auto 10px;
    border-bottom: 1px solid ${theme.colors.black[300]};
`;

interface Props {
    onSelect: (groundingState: AgentGrounding) => void;
}

export const GroundingList = ({ onSelect }: Props) => (
    <StyledList>
        {Object.values(GroundingStates).map((item, index) => (
            <React.Fragment key={item.groundingState}>
                <GroundingListItem key={item.title} item={item} onSelect={onSelect} />
                {index < Object.values(GroundingStates).length - 1 && <StyledListDivider />}
            </React.Fragment>
        ))}
    </StyledList>
);
